import React, { useContext, useEffect, useRef, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Row, Col } from "react-bootstrap";
import { LabelFieldComponent } from "../../components/fields";
import { ButtonComponent } from "../../components/elements";
import PageLayout from "../../layouts/PageLayout";
import Calendar from 'react-calendar';
import { checkCustomer, createCustomer, updateCustomer } from "../../APIs/CustomersRequests";
import { toast } from 'react-toastify';
import PulseLoader from "react-spinners/PulseLoader";
import 'react-calendar/dist/Calendar.css';
import SignatureCanvas from 'react-signature-canvas'
import { createSim } from "../../APIs/SimsRequests";
import { useNavigate } from "react-router-dom";
import { getAllCountries, getSettings } from "../../APIs/SettingRequests";
import LabelFieldPhoneComponent from "../../components/fields/LabelFieldPhoneComponent";

export default function CustomerCreatePage() {


    const { t } = useContext(TranslatorContext);
    const navigate = useNavigate();

    const textRejex = /[^a-zA-Z ]/g;
    const documentNumberRejex = /[^a-zA-Z0-9 ._\-]/g;

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [documentType, setDocumentType] = useState('national_id');
    const [type, setType] = useState('individual');
    const [isCitizen, setIsCitizen] = useState('0');
    const [nationality, setNationality] = useState('');
    const [occupation, setOccupation] = useState('');
    const [documentNumber, setDocumentNumber] = useState('');
    const [birthDate, setBirthDate] = useState('');
    const [documentExpiryDate, setDocumentExpiryDate] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [address, setAddress] = useState('');
    const [image, setImage] = useState('');
    const [supportDocument, setSupportDocument] = useState('');
    const [signatureImage, setSignatureImage] = useState('');
    const [documentImageFront, setDocumentImageFront] = useState('');
    const [documentImageBack, setDocumentImageBack] = useState('');
    const [permissionLitterImage, setPermissionLitterImage] = useState('');



    const [documentImageFrontError, setDocumentImageFrontError] = useState('');
    const [documentImageBackError, setDocumentImageBackError] = useState('');
    const [nameError, setNameError] = useState('');
    const [nationalityError, setNationalityError] = useState('');
    const [documentNumberError, setDocumentNumberError] = useState('');
    const [occupationError, setOccupationError] = useState('');
    const [birthDateError, setBirthDateError] = useState('');
    const [documentExpiryDateError, setDocumentExpiryDateError] = useState('');

    const [emailError, setEmailError] = useState('');
    const [phoneNumberError, setPhoneNumberError] = useState('');
    const [addressError, setAddressError] = useState('');
    const [imageError, setImageError] = useState('');
    const [signatureImageError, setSignatureImageError] = useState('');
    const [permissionLitterImageError, setPermissionLitterImageError] = useState('');
    const [maxSimsNumberError, setMaxSimsNumberError] = useState('');
    const [supportDocumentError, setSupportDocumentError] = useState('');



    const [simSerialNumber, setSimSerialNumber] = useState('');
    const [simNumber, setSimNumber] = useState('');
    const [simPuk, setSimPuk] = useState('');

    const [simSerialNumberError, setSimSerialNumberError] = useState('');
    const [simNumberError, setSimNumberError] = useState('');
    const [simPukError, setSimPukError] = useState('');


    const [imagePreview, setImagePreview] = useState('');
    const [supportDocumentPreview, setSupportDocumentPreview] = useState('');
    const [documentImageFrontPreview, setDocumentImageFrontPreview] = useState('');
    const [documentImageBackPreview, setDocumentImageBackPreview] = useState('');
    const [permissionLitterImagePreview, setPermissionLitterImagePreview] = useState('');


    const [maxSimsNumber, setMaxSimsNumber] = useState(0);
    const [createdSimsNumber, setCreatedSimsNumber] = useState(0);

    const [showCustomerBasicDetails, setShowCustomerBasicDetails] = useState(true);
    const [showCustomerDetails, setShowCustomerDetails] = useState(false);
    const [showSimDetails, setShowSimDetails] = useState(false);
    const [loading, setLoading] = useState(false);
    const [checkCustomerResponse, setCheckCustomerResponse] = useState(null);

    const [viewFinishButton, setViewFinishButton] = useState(false);
    const [allowedSimsNumber, setAllowedSimsNumber] = useState(0);
    const [customerImageRequired, setCustomerImageRequired] = useState(0);

    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState('');
    const [defaultCountry, setDefaultCountry] = useState(null);

    const [documentTypesList, setDocumentTypesList] = useState([
        { id: 'national_id', name: t('national_id') },
        { id: 'passport', name: t('passport') },
        { id: 'driving_license', name: t('driving_license') },
        { id: 'refugee_id', name: t('refugee_id') },
    ]);

    const [settingData, setSettingData] = useState(null);

    const [customerTypes, setCustomerTypes] = useState([
        { id: 'individual', name: t('individual') },
        { id: 'company', name: t('company') },
    ]);

    const yesterdayBase = new Date();
    const tomorrowBase = new Date();
    let yesterday = new Date(yesterdayBase);
    let tomorrow = new Date(tomorrowBase);
    yesterday.setDate(yesterdayBase.getDate() - 2);
    tomorrow.setDate(tomorrowBase.getDate() + 1);
    useEffect(() => {
        getSettingsAction();
        getAllCountriesAction();
        custmerAllowedTypesCheck();

    }, []);


    const custmerAllowedTypesCheck = () => {
        const defaultCustomerTypes = [
            { id: 'individual', name: t('individual') },
            { id: 'company', name: t('company') },
        ];

        const defaultDocumentTypesList = [
            { id: 'national_id', name: t('national_id') },
            { id: 'passport', name: t('passport') },
            { id: 'driving_license', name: t('driving_license') },
            { id: 'refugee_id', name: t('refugee_id') },
        ];

        const permissions = localStorage.getItem('permissions');
        if (permissions.includes('adding company type') && permissions.includes('adding individual type')) {
             setCustomerTypes(defaultCustomerTypes);
        } else if (permissions.includes('adding company type')) {
             setCustomerTypes(customerTypes.filter(item => item.id === 'company'));
            setDocumentTypesList([
                                                        { id: 'private', name: t('private') },
                                                        { id: 'ngo', name: t('ngo') },
                                                        { id: 'gov', name: t('gov') },
                                                        { id: 'semi_gov', name: t('semi_gov') },
                                                    ]);
        } else if (permissions.includes('adding individual type')) {
             setCustomerTypes(customerTypes.filter(item => item.id === 'individual'));
        }
        
    };

    const signatureRef = useRef(null);

    const getAllCountriesAction = (page=1) => {
        getAllCountries(1,1000).then((res) => {
            setCountries(res.data.data);
            setSelectedCountry(res.data.data[0]?.id || '');
        }).catch((error) => {
        }).finally(() => {
        });
    }

    const handleSaveSignature = () => {
        if (signatureRef.current) {
            if (signatureRef.current) {
                setSignatureImage(signatureRef.current.toDataURL("image/png"));
            } else {
                console.error("SignatureCanvas reference is null");
            }
        }
    };

    // Function to clear the signature canvas
    const handleClearSignature = () => {
        if (signatureRef.current) {
            signatureRef.current.clear();
        }
    };

    // Add loading state for the create/update button
    const [createLoading, setCreateLoading] = useState(false);

    const handleCreateCustomer = () => {
        let hasError = false;

        if (image === '' && customerImageRequired) {
            setImageError(t('image is required'));
            hasError = true;
        }

        if (signatureImage === '') {
            setSignatureImageError(t('signature_image is required'));
            hasError = true;
        }

        if (permissionLitterImage === '' && type === 'company') {
            setPermissionLitterImageError(t('permission_litter_image is required'));
            hasError = true;
        }
        if (maxSimsNumber === '') {
            setMaxSimsNumberError(t('maximum_sims_number is required'));
            hasError = true;
        }

        if (hasError) {
            return;
        }

        setCreateLoading(true); // Start loading

        const formData = new FormData();
        formData.append('name', name);
        formData.append('email', email);
        formData.append('document_type', documentType);
        formData.append('type', type);
        formData.append('is_citizen', isCitizen);
        formData.append('nationality', countries.find(item => item.id == selectedCountry)?.name);
        formData.append('occupation', occupation);
        formData.append('document_number', documentNumber);
        formData.append('birth_date', birthDate);
        formData.append('document_expiry_date', documentExpiryDate);
        formData.append('phone_number', phoneNumber);
        formData.append('address', address);

        if (image) formData.append('image', image);
        if (signatureImage) formData.append('signature_image', signatureImage);
        if (documentImageFront) formData.append('document_image_front', documentImageFront);
        if (documentImageBack) formData.append('document_image_back', documentImageBack);
        if (permissionLitterImage) formData.append('permission_litter_image', permissionLitterImage);
        if (supportDocument) formData.append('support_document_image', supportDocument);


        createCustomer(formData)
            .then((res) => {
                setShowCustomerBasicDetails(false);
                setShowCustomerDetails(false);
                setShowSimDetails(true);
                setCheckCustomerResponse(res.data.data);

                const notify = () => toast.success(res.data.message);
                notify();
            }).catch((error) => {
            }).finally(() => {
                setCreateLoading(false); // Stop loading
            });
    }

    const handleUpdateCustomer = (customerId) => {
        let hasError = false;

        if (image === '' && customerImageRequired) {
            setImageError(t('image is required'));
            hasError = true;
        }


        if (signatureImage === '') {
            setSignatureImageError(t('signature_image is required'));
            hasError = true;
        }

        if (permissionLitterImage === '' && type === 'company') {
            setPermissionLitterImageError(t('permission_litter_image is required'));
            hasError = true;
        }
        if (maxSimsNumber === '') {
            setMaxSimsNumberError(t('maximum_sims_number is required'));
            hasError = true;
        }

        if (hasError) {
            return;
        }

        setCreateLoading(true); // Start loading

        const formData = new FormData();
        formData.append('name', name);
        formData.append('email', email);
        formData.append('document_type', documentType);
        formData.append('type', type);
        formData.append('is_citizen', isCitizen);
        formData.append('nationality', countries.find(item => item.id == selectedCountry)?.name);
        formData.append('occupation', occupation);
        formData.append('document_number', documentNumber);
        formData.append('birth_date', birthDate);
        formData.append('document_expiry_date', documentExpiryDate);
        formData.append('phone_number', phoneNumber);
        formData.append('address', address);

        if (image) formData.append('image', image);
        if (signatureImage) formData.append('signature_image', signatureImage);
        if (documentImageFront) formData.append('document_image_front', documentImageFront);
        if (documentImageBack) formData.append('document_image_back', documentImageBack);
        if (permissionLitterImage) formData.append('permission_litter_image', permissionLitterImage);
        if (supportDocument) formData.append('support_document_image', supportDocument);


        updateCustomer(customerId, formData)
            .then((res) => {
                setShowCustomerBasicDetails(false);
                setShowCustomerDetails(false);
                setShowSimDetails(true);
                setCheckCustomerResponse(res.data.data);

                const notify = () => toast.success(res.data.message);
                notify();
            }).catch((error) => {
            }).finally(() => {
                setCreateLoading(false); // Stop loading
            });
    }

    // Also add loading state for check customer button
    const [checkLoading, setCheckLoading] = useState(false);

    const handleCheckCustomer = () => {
        let hasError = false;

        if (name === '') {
            setNameError(t('name is required'));
            hasError = true;
        }
        if (documentImageFront === '') {
            setDocumentImageFrontError(t('document_image_front is required'));
            hasError = true;
        }

        if (type !== 'company' && selectedCountry === '') {
            setNationalityError(t('nationality is required'));
            hasError = true;
        }
        if (documentNumber === '') {
            setDocumentNumberError(t('document_number is required'));
            hasError = true;
        }

        if (type !== 'company' && birthDate === '') {
            setBirthDateError(t('birth_date is required'));
            hasError = true;
        }
        if (documentExpiryDate === '') {
            setDocumentExpiryDateError(t('document_expiry_date is required'));
            hasError = true;
        }

        if (hasError) {
            return;
        }

        setCheckLoading(true); // Start loading

        checkCustomer(documentNumber, documentType, name, birthDate, type).then((res) => {
            setCheckCustomerResponse(res.data.data);
            if (res.data.data.is_blocked === 1) {
                setShowCustomerBasicDetails(true);
                setShowCustomerDetails(false);
                setShowSimDetails(false);
                const notify = () => toast.error(res.data.data.block_reason);
                notify();
            } else {
                setShowCustomerBasicDetails(false);
                setShowCustomerDetails(true);
                setShowSimDetails(false);
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
                const notify = () => toast.success(t('you are verified to add sim cards'));
                notify();
            }
        }).catch((error) => {
            console.log(error);
        }).finally(() => {
            setCheckLoading(false); // Stop loading
        });
    }

    // Add loading state for add sim button
    const [addSimLoading, setAddSimLoading] = useState(false);

    const handleAddSim = () => {
        let hasError = false;
        if (simSerialNumber === '') {
            setSimSerialNumberError(t('sim_serial_number is required'));
            hasError = true;
        } else if (simSerialNumber.length !== 16) {
            setSimSerialNumberError(t('sim_serial_number should be 16 characters'));
            hasError = true;
        }

        if (simNumber === '') {
            setSimNumberError(t('sim_number is required'));
            hasError = true;
        } else if (simNumber.length !== 12) {
            setSimNumberError(t('sim_number should be 12 characters'));
            hasError = true;
        }

        if (simPuk === '') {
            setSimPukError(t('sim_puk is required'));
            hasError = true;
        } else if (simPuk.length !== 6) {
            setSimPukError(t('sim_puk should be 6 characters'));
            hasError = true;
        }
        if (hasError) {
            return;
        }
        if (createdSimsNumber <= maxSimsNumber && createdSimsNumber <= allowedSimsNumber) {
            setAddSimLoading(true); // Start loading

            createSim(simSerialNumber, simNumber, simPuk, checkCustomerResponse.id)
                .then((res) => {
                    setShowCustomerBasicDetails(false);
                    setShowCustomerDetails(false);
                    setShowSimDetails(true);
                    setSimSerialNumber('');
                    setSimNumber('');
                    setSimPuk('');
                    setViewFinishButton(true);
                    setSimSerialNumberError('');
                    setSimNumberError('');
                    setSimPukError('');
                    const notify = () => toast.success(res.data.message);
                    notify();

                    if ((createdSimsNumber + 1) == maxSimsNumber || (createdSimsNumber + 1) == allowedSimsNumber) {
                        // redirect to customer list
                        window.location.href = '/customer-list';
                    }
                    setCreatedSimsNumber(createdSimsNumber + 1);

                }).catch((error) => {
                    console.log(error);
                }).finally(() => {
                    setAddSimLoading(false); // Stop loading
                });
        } else {
            const notify = () => toast.error(t('You can only create ') + createdSimsNumber + t(' sims'));
            notify();
        }
    }

    const getSettingsAction = () => {
        getSettings().then(res => {
            setSettingData(res.data.data);

            const defaultCountrySetting = res.data.data.find(setting => setting.key === 'default_country');
            if (defaultCountrySetting) {
                setDefaultCountry(parseInt(defaultCountrySetting.value));
            }

            const customerImageRequired = res.data.data.find(item => item.key === 'customer_image_mandatory');
            if (customerImageRequired) {
                setCustomerImageRequired(customerImageRequired.value === 'true' ? true : false);
            }
            handleSetAllowedSimsNumber('individual', '0', res.data.data);

        });
    };

    const handleSetAllowedSimsNumber = (customerType, customerIsCitizen, sourceData = settingData) => {
        let allowedSimsNumber = 0;
        sourceData?.map(item => {

            if (item.key === 'local_individual_sims_number' && customerIsCitizen === '1' && customerType === 'individual') {
                allowedSimsNumber = item.value;
            } else if (item.key === 'foreign_individual_sims_number' && customerIsCitizen === '0' && customerType === 'individual') {
                allowedSimsNumber = item.value;
            } else if (item.key === 'company_sims_number' && customerType === 'company') {
                allowedSimsNumber = item.value;
            }
        });
        //console.log('allowedSimsNumber',allowedSimsNumber);
        setAllowedSimsNumber(allowedSimsNumber);
    }

    const handleFinish = () => {
        navigate('/customer-list');
    }


    if (loading) {
        return (
            <div className="mc-spinner">
                <img className="pattern" src="images/pattern.webp" alt="pattern" />
                <img className="favicon" src="images/logo.webp" alt="logo" />
                <div className="mc-spinner-group">
                    <h3>Loading</h3>
                    <PulseLoader
                        color="#0857f5"
                        loading={loading}
                        size={8}
                    />
                </div>
            </div>
        );
    } else {
        return (
            <PageLayout>
                <Row>
                    <Col xl={12}>
                        <div className="mc-card">
                            <div className='mc-breadcrumb'>
                                {
                                    showCustomerBasicDetails ?
                                        <h3 className="mc-breadcrumb-title">{t('create_customer')}</h3> :
                                        showCustomerDetails ?
                                            <h3 className="mc-breadcrumb-title">{t('customer_details')}</h3> :
                                            <h3 className="mc-breadcrumb-title">{t('sim_details')}</h3>
                                }

                            </div>
                        </div>
                    </Col>
                    <Col xl={12}>
                        <div className="mc-card">
                            {
                                showCustomerBasicDetails &&
                                <div className="mc-tab-card">
                                    <Row>
                                        <Col xl={6}>
                                            <LabelFieldComponent label={t('type')} required fieldSize="w-100 h-md" option={customerTypes} value={type}
                                                onChange={(e) => {
                                                    setType(e.target.value)
                                                    if (e.target.value === 'individual') {
                                                        setDocumentTypesList([
                                                            { id: 'national_id', name: t('national_id') },
                                                            { id: 'passport', name: t('passport') },
                                                            { id: 'driving_license', name: t('driving_license') },
                                                            { id: 'refugee_id', name: t('refugee_id') },
                                                        ])
                                                    }
                                                    else if (e.target.value === 'company') {
                                                        setDocumentTypesList([
                                                            { id: 'private', name: t('private') },
                                                            { id: 'ngo', name: t('ngo') },
                                                            { id: 'gov', name: t('gov') },
                                                            { id: 'semi_gov', name: t('semi_gov') },
                                                        ])
                                                    }
                                                    handleSetAllowedSimsNumber(e.target.value, isCitizen);
                                                }}
                                            />
                                        </Col>
                                        <Col xl={6}><LabelFieldComponent label={t('document_type')} required fieldSize="w-100 h-md" option={documentTypesList} value={documentType} onChange={(e) => setDocumentType(e.target.value)} /></Col>
                                        {
                                            type !== 'company' &&
                                            <Col xl={12}><LabelFieldComponent label={t('is_citizen')} required fieldSize="w-100 h-md" option={[{ id: '0', name: t("no") }, { id: '1', name: t("yes") }]} value={isCitizen} onChange={(e) => { setIsCitizen(e.target.value); handleSetAllowedSimsNumber(type, e.target.value) }} /></Col>

                                        }

                                        <Col xl={6}>
                                            <h6 className="mc-divide-title mb-4">{t('document_image_front')} <span style={{ color: 'red' }}>*</span></h6>

                                            <div className={`mc-file-upload button`}>
                                                <input type="file" id={"document_image_front"}
                                                    onChange={(e) => {
                                                        setDocumentImageFront(e.target.files?.[0]);
                                                        setDocumentImageFrontError('');
                                                        if (e.target.files?.[0]) {
                                                            const reader = new FileReader();
                                                            reader.onloadend = () => {
                                                                setDocumentImageFrontPreview(reader.result);
                                                            };
                                                            reader.readAsDataURL(e.target.files?.[0]);
                                                        } else {
                                                            setDocumentImageFrontPreview(null); //
                                                        }

                                                    }} />
                                                <label htmlFor={"document_image_front"}>
                                                    <i className="material-icons">{'cloud_upload'}</i>
                                                    <span>{t('upload')}</span>
                                                </label>
                                            </div>
                                            {
                                                documentImageFrontError !== '' && <span className="mc-label-field" style={{ color: 'red' }} >{t(documentImageFrontError)}</span>
                                            }
                                            {documentImageFrontPreview && (
                                                <div className="mc-product-view-gallery mt-4">
                                                    <img src={documentImageFrontPreview} alt="uploaded" />
                                                </div>
                                            )}
                                        </Col>
                                        <Col xl={6}>
                                            <h6 className="mc-divide-title mb-4">{t('document_image_back')}</h6>

                                            <div className={`mc-file-upload button`}>
                                                <input type="file" id={"document_image_back"}
                                                    onChange={(e) => {
                                                        setDocumentImageBack(e.target.files?.[0]);
                                                        setDocumentImageBackError('');
                                                        if (e.target.files?.[0]) {
                                                            const reader = new FileReader();
                                                            reader.onloadend = () => {
                                                                setDocumentImageBackPreview(reader.result);
                                                            };
                                                            reader.readAsDataURL(e.target.files?.[0]);
                                                        } else {
                                                            setDocumentImageBackPreview(null); //
                                                        }
                                                    }} />
                                                <label htmlFor={"document_image_back"}>
                                                    <i className="material-icons">{'cloud_upload'}</i>
                                                    <span>{t('upload')}</span>
                                                </label>
                                            </div>
                                            {
                                                documentImageBackError !== '' && <span className="mc-label-field" style={{ color: 'red' }} >{t(documentImageBackError)}</span>
                                            }
                                            {documentImageBackPreview && (
                                                <div className="mc-product-view-gallery mt-4">
                                                    <img src={documentImageBackPreview} alt="uploaded" />
                                                </div>
                                            )}
                                        </Col>
                                        <Col xl={12}><LabelFieldComponent errorMessage={nameError} required type="text" label={type !== 'company' ? t('fullname') : t('name')} fieldSize="w-100 h-md" onChange={(e) => { setName(e.target.value.replace(textRejex, '')); setNameError('') }} value={name} /></Col>

                                        {
                                            type !== 'company' &&
                                            <Col xl={6}><LabelFieldComponent label={t('nationality')}  disabled={isCitizen == '1'} required fieldSize="w-100 h-md" option={countries} value={isCitizen == '0' ? selectedCountry :defaultCountry} onChange={(e)=> {setSelectedCountry(e.target.value);setNationalityError('')}}/></Col>
                                        }
                                        <Col xl={6}><LabelFieldComponent errorMessage={documentNumberError} required type="text" label={t('document_number')} fieldSize="w-100 h-md" value={documentNumber} onChange={(e) => { setDocumentNumber(e.target.value.replace(documentNumberRejex, '')); setDocumentNumberError('') }} /></Col>
                                        {
                                            type !== 'company' &&
                                            <Col xl={12}><LabelFieldComponent errorMessage={occupationError} type="text" label={t('occupation')}  fieldSize="w-100 h-md" value={occupation} onChange={(e)=> {setOccupation(e.target.value.replace(textRejex, ''));setOccupationError('')}}/></Col>
                                        }

                                        {
                                            type !== 'company' &&
                                            <Col xl={6}>
                                                <label className="mc-label-field-title">{t('birth_date')} <span style={{ color: 'red' }}>*</span></label>
                                                <Calendar
                                                    onChange={(e) => {
                                                        const year = e.getFullYear();
                                                        const month = String(e.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                                                        const day = String(e.getDate()).padStart(2, '0');
                                                        setBirthDate(`${year}-${month}-${day}`);
                                                        setBirthDateError('');
                                                    }}
                                                    value={birthDate}
                                                    maxDate={yesterday}
                                                />
                                                {
                                                    birthDateError !== '' && <span className="mc-label-field" style={{ color: 'red' }} >{t(birthDateError)}</span>
                                                }
                                            </Col>
                                        }
                                        
                                        <Col xl={6}>
                                            <label className="mc-label-field-title">{t('document_expiry_date')}<span style={{ color: 'red' }}>*</span></label>
                                            <Calendar
                                                onChange={(e) => {
                                                    const year = e.getFullYear();
                                                    const month = String(e.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                                                    const day = String(e.getDate()).padStart(2, '0');
                                                    setDocumentExpiryDate(`${year}-${month}-${day}`);
                                                    setDocumentExpiryDateError('');
                                                }}
                                                value={documentExpiryDate}
                                                minDate={tomorrow}
                                            />
                                            {
                                                documentExpiryDateError !== '' && <span className="mc-label-field" style={{ color: 'red' }} >{t(documentExpiryDateError)}</span>
                                            }
                                        </Col>
                                    </Row>
                                    <ButtonComponent className="mc-btn primary" icon="verified" text={t('check')} style={{ marginTop: '10px' }} onClick={() => handleCheckCustomer()} />

                                </div>
                            }


                            {
                                showCustomerDetails &&
                                <div className="mc-tab-card">
                                    <Row>
                                        <Col xl={12}><LabelFieldComponent required type="text" label={t('maximum_sims_number') + ' ' + allowedSimsNumber} fieldSize="w-100 h-md" onChange={(e) => {
                                            if (parseInt(e.target.value) > parseInt(allowedSimsNumber)) {
                                                const notify = () => toast.error(t('You can only add ') + allowedSimsNumber + t(' sims'));
                                                notify();
                                            } else {
                                                setMaxSimsNumber(e.target.value)
                                            }

                                        }} value={maxSimsNumber} />
                                            {
                                                maxSimsNumberError !== '' && <span className="mc-label-field" style={{ color: 'red' }} >{t(maxSimsNumberError)}</span>
                                            }
                                        </Col>
                                        <Col xl={12}>
                                            <LabelFieldComponent type="text" label={t('email')} fieldSize="w-100 h-md" onChange={(e) => setEmail(e.target.value)} value={email} />
                                            {
                                                emailError !== '' && <span className="mc-label-field" style={{ color: 'red' }} >{t(emailError)}</span>
                                            }
                                        </Col>
                                        <Col xl={6}>
                                            <LabelFieldPhoneComponent 
                                                type="text" 
                                                label={t('alternative_phone_number')}  
                                                fieldSize="w-100 h-md" 
                                                value={phoneNumber} 
                                                onChange={setPhoneNumber}
                                                onCountryChange={()=>{
                                                    console.log('onCountryChange');
                                                }}
                                                defaultCountry={isCitizen == '1' ? countries.find(country => country.id == defaultCountry).iso2 : countries.find(country => country.id == selectedCountry).iso2}
                                            />
                                            {
                                                phoneNumberError !== '' && <span className="mc-label-field"  style={{ color:'red'}} >{t(phoneNumberError)}</span>
                                            }
                                        </Col>
                                        <Col xl={6}><LabelFieldComponent type="text" label={t('address')} fieldSize="w-100 h-md" value={address} onChange={(e) => setAddress(e.target.value)} />
                                            {
                                                addressError !== '' && <span className="mc-label-field" style={{ color: 'red' }} >{t(addressError)}</span>
                                            }
                                        </Col>


                                        <Col xl={6}>
                                            {
                                                type === 'company' ?
                                                    <h6 className="mc-divide-title mb-4">{t('employee_id')}{customerImageRequired && <span style={{ color: 'red' }}>{'*'}</span>}</h6> :
                                                    <h6 className="mc-divide-title mb-4">{t('image')}{customerImageRequired && <span style={{ color: 'red' }}>{'*'}</span>}</h6>
                                            }


                                            <div className={`mc-file-upload button`}>
                                                <input type="file" id={"image"}
                                                    onChange={(e) => {
                                                        setImage(e.target.files?.[0]);
                                                        if (e.target.files?.[0]) {
                                                            const reader = new FileReader();
                                                            reader.onloadend = () => {
                                                                setImagePreview(reader.result);
                                                            };
                                                            reader.readAsDataURL(e.target.files?.[0]);
                                                        } else {
                                                            setImagePreview(null);
                                                        }
                                                    }} />
                                                <label htmlFor={"image"}>
                                                    <i className="material-icons">{'cloud_upload'}</i>
                                                    <span>{t('upload')}</span>
                                                </label>
                                            </div>

                                            {imagePreview && (
                                                <div className="mc-product-view-gallery mt-4">
                                                    <img src={imagePreview} alt="uploaded" />
                                                </div>
                                            )}

                                            {
                                                imageError !== '' && <span className="mc-label-field" style={{ color: 'red' }} >{t(imageError)}</span>
                                            }
                                        </Col>

                                        <Col xl={6}>
                                            {
                                                <h6 className="mc-divide-title mb-4">{t('support_document')}</h6>
                                            }


                                            <div className={`mc-file-upload button`}>
                                                <input type="file" id={"support_document"}
                                                    onChange={(e) => {
                                                        //console.log('setImage', e.target.files?.[0]);
                                                        setSupportDocument(e.target.files?.[0]);
                                                        if (e.target.files?.[0]) {
                                                            const reader = new FileReader();
                                                            reader.onloadend = () => {
                                                                setSupportDocumentPreview(reader.result);
                                                            };
                                                            reader.readAsDataURL(e.target.files?.[0]);
                                                        } else {
                                                            setSupportDocumentPreview(null); //
                                                        }
                                                    }} />
                                                <label htmlFor={"support_document"}>
                                                    <i className="material-icons">{'cloud_upload'}</i>
                                                    <span>{t('upload')}</span>
                                                </label>
                                            </div>

                                            {supportDocumentPreview && (
                                                <div className="mc-product-view-gallery mt-4">
                                                    <img src={supportDocumentPreview} alt="uploaded" />
                                                </div>
                                            )}

                                            {
                                                supportDocumentError !== '' && <span className="mc-label-field" style={{ color: 'red' }} >{t(supportDocumentError)}</span>
                                            }
                                        </Col>
                                        <Col xl={6}>
                                            <h6 className="mc-divide-title mb-4">{t('signature_image')} <span style={{ color: 'red' }}>*</span></h6>

                                            {/* <div className={`mc-file-upload button`}>
                                                <input type="file" id={"signature_image"} 
                                                onChange={(e) => {
                                                    // setSignatureImage(e.target.files?.[0]);
                                                    if (e.target.files?.[0]) {
                                                        const reader = new FileReader();
                                                        reader.onloadend = () => {
                                                            setSignatureImagePreview(reader.result); 
                                                            setSignatureImage(reader.result)
                                                        };
                                                        reader.readAsDataURL(e.target.files?.[0]);
                                                    } else {
                                                        setSignatureImagePreview(null); //
                                                    }
                                                }}/>
                                                <label htmlFor={"signature_image"}>
                                                    <i className="material-icons">{'cloud_upload'}</i>
                                                    <span>{ t('upload') }</span>
                                                </label>
                                            </div> */}


                                            <div className="mc-product-view-gallery mt-4" style={{ border: '1px solid #000' }}>
                                                <SignatureCanvas
                                                    ref={signatureRef}
                                                    penColor='black'
                                                    borderColor='black'
                                                    canvasProps={{ width: 400, height: 400, className: 'sigCanvas', border: '1px solid #000' }}
                                                    onEnd={handleSaveSignature}
                                                />
                                            </div>
                                            <ButtonComponent style={{ marginTop: '20px' }} className="mc-btn primary" icon="verified" text={t('clear_signature')} onClick={() => {
                                                signatureRef.current.clear();
                                                setSignatureImage('');
                                            }} />
                                            {
                                                signatureImageError !== '' && <span className="mc-label-field" style={{ color: 'red' }} >{t(signatureImageError)}</span>
                                            }
                                        </Col>
                                        {
                                            type === 'company' &&
                                            <Col xl={6}>
                                                <h6 className="mc-divide-title mb-4">{t('permission_litter_image')} <span style={{ color: 'red' }}>*</span></h6>

                                                <div className={`mc-file-upload button`}>
                                                    <input type="file" id={"permission_litter_image"}
                                                        onChange={(e) => {
                                                            setPermissionLitterImage(e.target.files?.[0]);
                                                            if (e.target.files?.[0]) {
                                                                const reader = new FileReader();
                                                                reader.onloadend = () => {
                                                                    setPermissionLitterImagePreview(reader.result);
                                                                };
                                                                reader.readAsDataURL(e.target.files?.[0]);
                                                            } else {
                                                                setPermissionLitterImagePreview(null); //
                                                            }
                                                        }} />
                                                    <label htmlFor={"permission_litter_image"}>
                                                        <i className="material-icons">{'cloud_upload'}</i>
                                                        <span>{t('upload')}</span>
                                                    </label>
                                                </div>
                                                {permissionLitterImagePreview && (
                                                    <div className="mc-product-view-gallery mt-4">
                                                        <img src={permissionLitterImagePreview} alt="uploaded" />
                                                    </div>
                                                )}
                                                <div>
                                                    {
                                                        permissionLitterImageError !== '' && <span className="mc-label-field" style={{ color: 'red' }} >{t(permissionLitterImageError)}</span>
                                                    }
                                                </div>
                                            </Col>
                                        }
                                    </Row>
                                    <ButtonComponent style={{ marginTop: '20px' }} className="mc-btn primary" icon="verified" text={checkCustomerResponse !== null ? t('create') : t('update')} onClick={() => {
                                        if (checkCustomerResponse !== null && checkCustomerResponse.id !== undefined) {
                                            handleUpdateCustomer(checkCustomerResponse.id);
                                        } else {
                                            handleCreateCustomer();
                                        }
                                    }} />

                                </div>
                            }
                            {
                                showSimDetails &&
                                <div className="mc-tab-card">
                                    <Row>
                                        <Col xl={12}><LabelFieldComponent maxlength={16} required errorMessage={simSerialNumberError} type="text" label={t('sim_serial_number')} fieldSize="w-100 h-md" onChange={(e) => {
                                            // if value contain characters skip them
                                            if (e.target.value.match(/^[0-9]+$/) || e.target.value === '') {
                                                setSimSerialNumberError('');
                                                setSimSerialNumber(e.target.value)
                                            }
                                        }} value={simSerialNumber} /></Col>
                                        <Col xl={12}><LabelFieldComponent maxlength={12} required errorMessage={simNumberError} type="text" label={t('sim_number')} fieldSize="w-100 h-md" onChange={(e) => {
                                            if (e.target.value.match(/^[0-9]+$/) || e.target.value === '') {
                                                setSimNumberError('');
                                                setSimNumber(e.target.value)
                                            }
                                        }} value={simNumber} /></Col>
                                        <Col xl={12}><LabelFieldComponent maxlength={6} required errorMessage={simPukError} type="text" label={t('sim_puk')} fieldSize="w-100 h-md" value={simPuk} onChange={(e) => {
                                            if (e.target.value.match(/^[0-9]+$/) || e.target.value === '') {
                                                setSimPukError('');
                                                setSimPuk(e.target.value)
                                            }
                                        }} /></Col>
                                    </Row>
                                    <ButtonComponent className="mc-btn primary" icon="verified" text={t('add')} onClick={() => handleAddSim()} />
                                    {
                                        viewFinishButton &&
                                        <ButtonComponent className="mc-btn primary" icon="verified" text={t('finish')} style={{ margin: '10px' }} onClick={() => handleFinish()} />
                                    }

                                </div>
                            }




                        </div>
                    </Col>
                </Row>
            </PageLayout>
        )
    }

}